import React, { Component } from 'react';
import DayQualityElement from './DayQualityElement';
import '@app/components/sqdp/cbm/styles/quality-layout.css';
import dayjs from 'dayjs';
import { getDayColorError, getDayColorGood, getDayColorWarn } from '@app/services/localStorage.service';

class QualityLayout extends Component {
  state = {
    showInfo: false,
    element: {},
  };

  showInfo = (num) => {
    this.props.showIssueInfo(num, 2, 'cbm');
  };

  getColorOfDay = (issueOfDay, dateNum) => {
    if (!issueOfDay) return 'emtpy_state';

    const {
      isRestDay,
      countQualityTotal = 0,
      highestQualityProductionDownTimeMinutes = 0,
      highestQualityErrorProductNumber = 0,
    } = issueOfDay;

    const thisDay = dayjs().date(dateNum).day();

    console.log(dayjs().date(dateNum));
    console.log(issueOfDay);

    // Ngày nghỉ cuối tuần
    if (isRestDay && (thisDay === 6 || thisDay === 0)) {
      return 'emtpy_state';
    }

    let today = dayjs();
    let selectedTime = dayjs(this.props.selectedMonth);
    if (
      today.get('month') <= selectedTime.get('month') &&
      today.get('year') <= selectedTime.get('year') &&
      dateNum > today.get('date')
    ) {
      return 'emtpy_state';
    }

    // 🔴 Có thời gian dừng sản xuất > 30 hoặc lỗi chất lượng cao > 3
    if (highestQualityProductionDownTimeMinutes > 30 || highestQualityErrorProductNumber > 3) {
      return 'red_state';
    }
    //🟢 Không dừng sản xuất và không lỗi chất lượng cao
    if (highestQualityProductionDownTimeMinutes === 0 && highestQualityErrorProductNumber === 0) {
      return 'green_state';
    }
    // 🟡 còn lại
    // (0 <  thời gian dừng sản xuất < 30 ) hoặc lỗi chất lượng cao
    return 'yellow_state';
  };

  populateElements = (start, end) => {
    let items = [];
    for (let i = start; i <= end; i++) {
      let issueOfDay = this.props.dataInMonth[i - 1];
      let color = this.getColorOfDay(issueOfDay, i);
      items.push(
        <DayQualityElement
          oneTypeIssue={this.props.oneTypeIssue}
          showInfo={this.showInfo}
          num={i}
          color={color}
          issues={issueOfDay}
          lastClickedElement={this.props.lastClickedElement}
          lastGroupClicked={this.props.lastGroupClicked}
        />,
      );
    }
    return items;
  };

  render() {
    return (
      // <div className="wrapper">
      <>
        <div id="table-quality">{this.populateElements(1, 31)}</div>
        <h3 className="center" style={{ paddingLeft: '30px', marginTop: '20px' }}>
          Quality
        </h3>
      </>
    );
  }
}

export default QualityLayout;
